import DesignTeamShifter from "../components/DesignTeamShifter"

export default class DesignTeamsTerritories {
  index() {
    new DesignTeamShifter()
  }
}
